import { Page } from '@/components/layout/Page';
import { ForecastChangeSignalsContainer } from '@/features/forecasts/components/home/ForecastChangeSignalsContainer';

export function FoundationForecastingHome() {
  return (
    <Page title="Home" subheader="(BFG v2.2)">
      <ForecastChangeSignalsContainer />
    </Page>
  );
}
